<template>
  <div ref="iframeContainer" class="h-full">
    <iframe
      frameborder="0"
      src="https://hrc.groovepages.com/gpiframes/groovecruise"
      class="w-full"
      style="overflow-y: hidden"
      :style="{ height: iframeHeight }"
      @load="load"
    ></iframe>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  middleware: 'auth',
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      iframeHeight: '200px',
      scrollbarSettings: {
        maxScrollbarLength: 60
      }
    };
  },
  metaInfo() {
    return { title: 'GrooveDigital' };
  },
  async created() {},
  async mounted() {
    /*
    console.log(
      'this is the offset height ' + this.$refs.iframeContainer.offsetTop
    );
    console.log(
      'this is the bouding rect height ' +
        this.$refs.iframeContainer.getBoundingClientRect().top
    );
    console.log(
      'this is iframe height ' +
        (window.innerHeight -
          this.$refs.iframeContainer.getBoundingClientRect().top)
    );
    */
  },
  methods: {
    load() {
      this.iframeHeight =
        window.innerHeight -
        this.$refs.iframeContainer.getBoundingClientRect().top +
        'px';
    }
  }
};
</script>

<style>
.reportrange-text {
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
}

.daterangepicker .ranges li.active {
  background-color: #fd6481;
}

.daterangepicker td.active,
.daterangepicker td.active:hover {
  background-color: #fd6481;
}
</style>

<style scoped>
.vue-daterange-picker {
  width: 100%;
  padding-left: 5px;
  padding-right: 5px;
}
</style>
